export class Product {
  constructor() {
    this.laboratory = null;
    this.name = null;
    this.category = null;
    this.presentation = null;
    this.quarter1Sales = 0;
    this.quarter2Sales = 0;
    this.quarter3Sales = 0;
    this.quarter4Sales = 0;
    this.quarter1Quantity = 0;
    this.quarter2Quantity = 0;
    this.quarter3Quantity = 0;
    this.quarter4Quantity = 0;
    this.description = "";
  }

  get totalSales() {
    let total = this.quarter1Sales + this.quarter2Sales + this.quarter3Sales + this.quarter4Sales;
    return Number(total.toFixed(2));
  }

  get totalQuantity() {
    let total =
      this.quarter1Quantity + this.quarter2Quantity + this.quarter3Quantity + this.quarter4Quantity;
    return Number(total.toFixed(2));
  }

  get valorUnitario() {
    if (this.totalQuantity === 0) {
      return 0;
    }
    let valor = this.totalSales / this.totalQuantity;
    return Number(valor.toFixed(2));
  }

  get valorUnitarioQuarter1() {
    if (this.quarter1Quantity === 0) {
      return 0;
    }
    let valor = this.quarter1Sales / this.quarter1Quantity;
    return Number(valor.toFixed(2));
  }
  get valorUnitarioQuarter2() {
    if (this.quarter2Quantity === 0) {
      return 0;
    }
    let valor = this.quarter2Sales / this.quarter2Quantity;
    return Number(valor.toFixed(2));
  }

  get valorUnitarioQuarter3() {
    if (this.quarter3Quantity === 0) {
      return 0;
    }
    let valor = this.quarter3Sales / this.quarter3Quantity;
    return Number(valor.toFixed(2));
  }

  get valorUnitarioQuarter4() {
    if (this.quarter4Quantity === 0) {
      return 0;
    }
    let valor = this.quarter4Sales / this.quarter4Quantity;
    return Number(valor.toFixed(2));
  }
}
